import axios from 'axios';
import { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import GestionAffichageSelection from './gestionAffichageSelection';



function GestionSelection(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const { idMatch } = useParams();
    const [joueur,setJoueur] = useState()
    const [creer,setCreer] = useState()
    const Navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;





    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/selection/gestion/coach/${props.userData.user.donnée.results[0].id_equipe}/${idMatch}`,
              {
                withCredentials: true 
              }
            );
            
            setError(null);
            setIsLoading(false);
            setJoueur(response.data);
    
          } catch (error) {
            if (error.response) {
              if (error.response.status === 404) {
                  setCreer(error.response.data);
              } else {
                  setError(error.response.data.message);
              }
          } else {
              setError(true);
          }
          setIsLoading(false);
      }
  };
    
        fetchData(); 
      }, [props, idMatch, apiUrl]);

      const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setCreer('')
        try {
          await axios.post(`${apiUrl}/selection/creation`, {
            idEquipe : props.userData.user.donnée.results[0].id_equipe,
            idMatch : idMatch
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 

        } catch (error) {
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };
    

  return (
    <>
      {creer && (
        <Modal show={creer} onHide={() => Navigate('/coach/tableau-de-bord/selection')}>
          <Modal.Header closeButton>
            <Modal.Title>Création d'une sélection</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>La sélection pour le match {creer.match[0].equipe_dom} - {creer.match[0].equipe_ext} n'est pas encore disponible. Voulez-vous la créer ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => Navigate('/coach/tableau-de-bord/selection')} >
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => {handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
              Créer
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    {joueur && joueur.selection && joueur.match_commentaire &&
      <GestionAffichageSelection joueur={joueur} userData={props.userData}/>
    }
    
    {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
    )}
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default GestionSelection;